import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function FloatingCTA() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 120);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Mobile sticky bottom bar */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-50 md:hidden transition-transform duration-300 ${
          visible ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <div className="flex bg-white border-t border-gray-200" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
          <a
            href="tel:+905076074165"
            className="flex-1 flex flex-col items-center justify-center gap-0.5 bg-blue-600 hover:bg-blue-700 text-white py-3.5 transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-lg"></i>
            </div>
            <span className="text-xs font-bold whitespace-nowrap">{t('nav.call')}</span>
          </a>
          <a
            href="https://wa.me/905076074165?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum."
            target="_blank"
            rel="nofollow noreferrer"
            className="flex-1 flex flex-col items-center justify-center gap-0.5 bg-green-500 hover:bg-green-600 text-white py-3.5 transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg"></i>
            </div>
            <span className="text-xs font-bold whitespace-nowrap">WhatsApp</span>
          </a>
        </div>
      </div>

      {/* Desktop floating WhatsApp bubble */}
      <a
        href="https://wa.me/905076074165?text=Merhaba%2C%20tesisat%20konusunda%20yard%C4%B1m%20istiyorum."
        target="_blank"
        rel="nofollow noreferrer"
        aria-label="WhatsApp ile yaz"
        className={`fixed bottom-8 right-6 z-50 hidden md:flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full transition-all duration-300 cursor-pointer ${
          visible ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
        }`}
        style={{ boxShadow: '0 4px 20px rgba(34,197,94,0.4)' }}
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </>
  );
}
